import SvgLoader from 'src/components/Common/SvgLoader';
import { Input } from '../../../Common/@electron/Input';

interface SearchInputTypes {
  formRef: React.RefObject<HTMLFormElement>;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  autoFocus?: boolean;
  value?: string;
}

export const SearchAccounts = ({ formRef, handleChange, value, ...rest }: SearchInputTypes) => (
  <form ref={formRef} onSubmit={e => e.preventDefault()}>
    <Input
      sizing="md"
      label="Search"
      aria-label="Search Accounts"
      id="search"
      name="search"
      type="search"
      defaultValue={''}
      autoComplete="on"
      onChange={handleChange}
      value={value}
      leadingIcon={
        <SvgLoader
          name="Search"
          className="inline mx-2"
          size={12}
          aria-hidden={true}
          focusable={false}
        />
      }
      {...rest}
    />
  </form>
);
